module.exports = __webpack_public_path__ + "static/media/packOpe.053ce215.png";